import React from "react";
import { changeUserGrantProtection } from "client/api/CloudSubscriptionApi";
import {
  ProtectUserGrantsDialog,
  type ProtectUserGrantsArguments,
} from "components/cloud-subscriptions/ProtectUserGrantsDialog";

type ProtectUserAccessDialogProps = {
  cloudSubscriptionId: string;
  currentValue: boolean;
  open: boolean;
  handleClose: () => void;
  onSaved: () => void;
};

export function ProtectUserAccessDialog({
  cloudSubscriptionId,
  currentValue,
  open,
  handleClose,
  onSaved,
}: ProtectUserAccessDialogProps) {
  const handleSubmit = async ({ isProtected }: ProtectUserGrantsArguments) => {
    await changeUserGrantProtection(cloudSubscriptionId, isProtected);
    handleClose();
    onSaved();
  };

  return (
    <ProtectUserGrantsDialog
      currentValue={currentValue}
      open={open}
      handleClose={handleClose}
      submitChange={handleSubmit}
    />
  );
}
